import { gql } from '@apollo/client';

export const GET_CAMPAIGNS = gql`
  query GetCampaignsForAdminPanel {
    getCampaignsForAdminPanel {
			url
			status
			endDate
			startDate
			brandName
			campaignId
			totalPosts
			totalBudget
			isRecurrent
			campaignTitle
			consumedBudget
			creatorsWithPosts
			creatorsRegistered
			totalRejectedPosts
			squad
		}
  }
`;

export const GET_PROJECTS = gql`
  query GetProjectsForAdminPanel {
    getProjectsForAdminPanel {
      projectId
      url
      status
      startDate
      endDate
      projectTitle
      brandName
      totalBudget
      hasTerms
      hasBriefing
      creatorsGoal
      approvedCreators
      completedPercent
      issues {
        pendingOptins
        pendingScriptSubmission
        pendingScriptApproval
        pendingContentSubmission
        pendingContentApproval
        pendingPost
        pendingPayment
      }
    }
  }
`;
